var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgALetter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aLet",
    width: 42,
    height: 49,
    viewBox: "0 0 42 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3215 19.7221V48.2561H33.2181V41.9564C30.4556 46.218 25.1146 48.6267 17.7479 48.6267C7.06602 48.6267 0.435913 42.8828 0.435913 34.7302C0.435913 27.1335 5.22432 21.0191 19.2212 21.0191H32.6656V19.3515C32.6656 12.1253 28.4297 8.04905 20.142 8.04905C14.617 8.04905 8.90771 10.0872 5.22432 13.0518L1.72509 6.56676C6.5135 2.67575 13.5119 0.452316 21.0629 0.452316C34.1389 0.637602 41.3215 6.93733 41.3215 19.7221ZM32.8498 33.8038V27.1335H19.7737C11.3019 27.1335 8.90771 30.4687 8.90771 34.3597C8.90771 38.9918 12.7753 41.9564 19.2212 41.9564C25.6671 42.1417 30.8239 39.3624 32.8498 33.8038Z",
    fill: "#FF6060"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgALetter);
export default __webpack_public_path__ + "static/media/aLetter.9a5d24e1df67082fd1c588e869cf9d09.svg";
export { ForwardRef as ReactComponent };